export const TOGGLEABLE_INFO_COLUMNS_BY_PAGE = {
    searchAds: ["campaign_google_ads_status", "campaign_google_ads_status_reason"],
};

export const getToggleableInfoColumns = (page) =>
    TOGGLEABLE_INFO_COLUMNS_BY_PAGE[page] || [];

export const isToggleableInfoColumn = (page, column) =>
    column?.type === "INFO" &&
    getToggleableInfoColumns(page).includes(column?.accessorKey);